import { Interval } from 'luxon';

export const getDaysSinceDate = (date: Date) => {
  const diff = Interval.fromDateTimes(new Date(date), new Date());
  const days = diff.length('days');

  return parseInt(`${days || 0}`) || 1;
};
